export interface ImageDetail {
    // image_id
    id?: number;
    sjc_group_sjc_inspection_image_id?: number;
    sjc_group_id?: number;
    action_name: string;
    caption: string;
    custom_caption: string;
    group_approved: boolean;
    sjc_id: number;
    custom_sjc_id?: number;
    custom_sjc_name?: number;
    sjc_inspection_image_id?: number;
    image_id: number;
    image_url: string;
    name: string;
    occurrence_rate: number;
    score: number;
    image_option_score: number;
    topic_name: string;
    webp: string;
    approved_all_makes?: boolean;
    manual_upload?: boolean;
    safety_caption: string | null;
    cost_caption: string | null;
    failure_term: string | null;
    safetyAndCostCaptionVisible?: boolean;
}

export interface Item {
    0: [string, number]
    1: ImageDetail[];
}

export interface GroupResponse {
    approved: null;
    image_limit: number;
    items: Item[];
    total_pages: number
}

export interface Group {
    id: number;
    name: string;
    occurrence_rate: number;
    upload_dialog_visible: boolean;
    search_dialog_visible: boolean;
}

export type InspectionImageEntity = {
    sjc_inspection_image_id: number;
    image_id: number;
    score_red_color: number;
    webp: string;
    make_id: number;
    approved: boolean;
    topic_name: string;
    action_name: string;
    caption: string;
    filename: string;
    manual_upload: boolean;
}


export enum ImageEditorImageType {
    GROUP_IMAGE = 'group_image',
    SEARCH_IMAGE = 'search_image'
}

export interface SJC {
    id: number;
    name: string;
    sub_category: string;
    category: string;
    display: string;
}